<template>
  <div class="profile-wrap">
    <h4 class="title">Редактирование профиля</h4>
    <DropzoneProfile :contacts="contacts" @unbind="unbind" @bind="bind"></DropzoneProfile>
    <Inputs
      class="group"
      type="text"
      placeholder="Имя, фамилия"
      subholder="Имя, фамилия"
      name="name"
      ref="name"
      v-on:input="oninput"
      :value="contacts.name.value"
    ></Inputs>
    <Inputs
      class="group"
      type="tel"
      placeholder="Телефон"
      subholder="Телефон"
      name="phone"
      ref="phone"
      v-on:input="oninput"
      :value="contacts.phone"
      :disabled="true"
    ></Inputs>
    <Inputs
      class="group"
      type="text"
      placeholder="Электронная почта"
      subholder="Email"
      name="email"
      ref="email"
      v-on:input="oninput"
      :value="contacts.email"
    ></Inputs>

    <span v-for="(social,key) in contacts.socials" :key="key">
      <Inputs
        class="group"
        type="text"
        :placeholder="social.placeholder"
        :subholder="social.subholder"
        :name="social.name"
        v-on:input="oninput"
        :value="social.view"
      ></Inputs>
    </span>
    
    <div class="btn-wrap disabled" ref="btnwrap">
      <span class="btn btn-outline-primary" @click="cancel">Отмена</span>
      <span class="btn btn-primary" @click="save">Готово</span>
    </div>
  </div>
</template>

<script>
import DropzoneProfile from "@/components/profile/DropzoneProfile.vue";
import Inputs from "@/components/basic/Input.vue";
import Inputmask from "inputmask";

export default {
  name: "CompletedProfile",
  components: {
    DropzoneProfile,
    Inputs
  },
  props: ["contacts"],
  methods: {
    unbind: function(type) {
      this.$refs.btnwrap.classList.remove("disabled");
      this.$parent.files_unbind(type);
    },
    bind: function(type) {
      this.$parent.files_bind(type);
    },
    oninput: function(val, target) {
      this.$refs.btnwrap.classList.remove("disabled");

      if (target.name === "phone") {
        if (!this.$refs.phone.getInput().inputmask.isComplete()) val = "";
      }
      let is_link =
        target.name !== "name" &&
        target.name !== "phone" &&
        target.name !== "email";
      this.$emit("print", target.name, val, is_link);
    },
    save: function() {
      this.$emit("save");
    },
    cancel: function() {
      this.$emit("cancel");
      this.$refs.btnwrap.classList.add("disabled");
    }
  },

  mounted: function() {
    this.$refs.phone.setAttr("autocomplete", "off");
    this.$refs.phone.setAttr("pattern", "\\d*");
    this.$refs.phone.setAttr("inputmode", "numeric");

    let im = new Inputmask({
        mask: "+7 999 999 99 99",
        placeholder: "+7 ___ ___ __ __"
      }),
      _inp = this.$refs.phone.getInput();
    im.mask(_inp);
    _inp.focus();
    _inp.blur();
    im = new Inputmask({
      mask: "*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}[.*{2,6}][.*{1,2}]"
    });
    _inp = this.$refs.email.getInput();
    im.mask(_inp);
    _inp.focus();
    _inp.blur();
  }
};
</script>

<style lang="scss" scope>
.profile-wrap {
  padding-bottom: 30px;
  min-height: calc(100vh - 112px);
  h4 {
    margin-bottom: 56px !important;
  }
}
</style>